import React from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  setFilterInBusinessRegister,
  setFilterInFoundationRegister,
  setFilterIsVatRegistered,
  setFilterOrganizationType,
  setFilterRegistrationFrom,
  setFilterRegistrationTo,
  setFilterEmployeesFrom,
  setFilterEmployeesTo,
} from "../../../../../redux/actions/new-list";
import { Input } from "../../../../library/input";
import { Label } from "../../../../library/label";
import { Select } from "../../../../library/select";

import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();

  const minEmployees = useSelector(
    (state) => state.newList.listFilter.employeesFrom
  );

  const setFilterRegistrationDateFrom = (date) => {
    dispatch(setFilterRegistrationFrom(date));
  };

  const setFilterRegistrationDateTo = (date) => {
    dispatch(setFilterRegistrationTo(date));
  };

  const selectFilterEmployeesFrom = (amount) => {
    dispatch(setFilterEmployeesFrom(amount));
  };

  const selectFilterEmployeesTo = (amount) => {
    dispatch(setFilterEmployeesTo(amount));
  };

  const selectFilterOrganizationType = (selection) => {
    dispatch(setFilterOrganizationType(selection));
  };

  const selectFilterIsVatRegistered = (selection) => {
    dispatch(setFilterIsVatRegistered(selection));
  };
  const selectFilterInBusinessRegister = (selection) => {
    dispatch(setFilterInBusinessRegister(selection));
  };

  const selectFilterInFoundationRegister = (selection) => {
    dispatch(setFilterInFoundationRegister(selection));
  };

  const organizationTypes = [
    {
      id: 0,
      value: "",
      title: "Velg",
      selected: true,
    },
    {
      id: 1,
      value: "AAFY",
      title: "AAFY - Ikke næringsdrivende virksomhet",
      selected: false,
    },
    {
      id: 2,
      value: "ADOS",
      title: "ADOS - Administrativ enhet -offentlig sektor",
      selected: false,
    },
    {
      id: 3,
      value: "ANNA",
      title: "ANNA - Annen juridisk person",
      selected: false,
    },
    {
      id: 4,
      value: "ANS",
      title: "ANS - Ansvarlig selskap med solidarisk ansvar",
      selected: false,
    },
    {
      id: 5,
      value: "AS",
      title: "AS - Aksjeselskap",
      selected: false,
    },
    {
      id: 6,
      value: "ASA",
      title: "ASA - Allmennaksjeselskap",
      selected: false,
    },
    {
      id: 7,
      value: "BA",
      title: "Selskap med begrenset ansvar",
      selected: false,
    },
    {
      id: 8,
      value: "BBL",
      title: "BBL - Boligbyggelag",
      selected: false,
    },
    {
      id: 9,
      value: "BEDR",
      title: "BEDR - Bedrift",
      selected: false,
    },
    {
      id: 10,
      value: "BO",
      title: "BO - Andre bo",
      selected: false,
    },
    {
      id: 11,
      value: "BRL",
      title: "BRL - Borettslag",
      selected: false,
    },
    {
      id: 12,
      value: "DA",
      title: "DA - Ansvarlig selskap med delt ansvar",
      selected: false,
    },
    {
      id: 13,
      value: "ENK",
      title: "ENK - Enkeltpersonforetak",
      selected: false,
    },
    {
      id: 14,
      value: "EØFG",
      title: "EØFG - Europeisk økonomisk foretaksgruppe",
      selected: false,
    },
    {
      id: 15,
      value: "ESEK",
      title: "ESEK - Eierseksjonssameie",
      selected: false,
    },
    {
      id: 16,
      value: "FKF",
      title: "Fylkeskommunalt foretak",
      selected: false,
    },
    {
      id: 17,
      value: "FLI",
      title: "FLI - Forening/lag/innretning",
      selected: false,
    },
    {
      id: 18,
      value: "FYLK",
      title: "FYLK - Fylkeskommune",
      selected: false,
    },
    {
      id: 19,
      value: "GFS",
      title: "GFS - Gjensidig forsikringsselskap",
      selected: false,
    },
    {
      id: 20,
      value: "IKJP",
      title: "IKJP - Andre ikke-juridiske personer",
      selected: false,
    },
    {
      id: 21,
      value: "IKS",
      title: "Interkommunalt selskap",
      selected: false,
    },
    {
      id: 22,
      value: "KBO",
      title: "KBO - Konkursbo",
      selected: false,
    },
    {
      id: 23,
      value: "KF",
      title: "KF - Kommunalt foretak",
      selected: false,
    },
    {
      id: 24,
      value: "KIRK",
      title: "KIRK - Den norske kirke",
      selected: false,
    },
    {
      id: 25,
      value: "KOMM",
      title: "KOMM - Kommune",
      selected: false,
    },
    {
      id: 26,
      value: "KS",
      title: "KS - Kommandittselskap",
      selected: false,
    },
    {
      id: 27,
      value: "KTRF",
      title: "KTRF - Kontorfellesskap",
      selected: false,
    },
    {
      id: 28,
      value: "NUF",
      title: "NUF - Norskregistrert utenlandsk foretak",
      selected: false,
    },
    {
      id: 29,
      value: "OPMV",
      title: "OPMV - Særskilt oppdelt enhet, jf. mval. § 2-2",
      selected: false,
    },
    {
      id: 30,
      value: "ORGL",
      title: "ORGL - Organisasjonsledd",
      selected: false,
    },
    {
      id: 31,
      value: "PERS",
      title:
        "PERS - Andre enkeltpersoner som registreres i tilknyttet register",
      selected: false,
    },
    {
      id: 32,
      value: "PK",
      title: "PK - Pensjonskasse",
      selected: false,
    },
    {
      id: 33,
      value: "PRE",
      title: "PRE - Partrederi",
      selected: false,
    },
    {
      id: 34,
      value: "SA",
      title: "SA - Samvirkeforetak",
      selected: false,
    },
    {
      id: 35,
      value: "SAM",
      title: "SAM - Tingsrettslig sameie",
      selected: false,
    },
    {
      id: 36,
      value: "SE",
      title: "SE - Europeisk selskap",
      selected: false,
    },
    {
      id: 37,
      value: "SF",
      title: "SF - Statsforetak",
      selected: false,
    },
    {
      id: 38,
      value: "SPA",
      title: "SPA - Sparebank",
      selected: false,
    },
    {
      id: 39,
      value: "STI",
      title: "STI - Stiftelse",
      selected: false,
    },
    {
      id: 40,
      value: "STAT",
      title: "STAT - Staten",
      selected: false,
    },
    {
      id: 41,
      value: "SÆR",
      title: "SÆR - Annet foretak ifølge særskilt lov",
      selected: false,
    },
    {
      id: 42,
      value: "TVAM",
      title: "TVAM - Tvangsregistrert for MVA",
      selected: false,
    },
    {
      id: 43,
      value: "VPFO",
      title: "VPFO - Verdipapirfond",
      selected: false,
    },
  ];

  const booleans = [
    {
      id: 0,
      value: "",
      title: "Velg",
      selected: true,
    },
    {
      id: 1,
      value: "true",
      title: "Ja",
      selected: false,
    },
    {
      id: 2,
      value: "false",
      title: "Nei",
      selected: false,
    },
  ];

  return (
    <div>
      <div className="tab-content-container">
        <div className="all-organization-container">
          <div className="details-container">
            <Row className="details-row">
              <Col md={6}>
                <Label version={1} weight="bold">
                  Ansatte fra
                </Label>
                <Input
                  placeholder="Velg"
                  onChange={(e) => selectFilterEmployeesFrom(e.target.value)}
                  min="0"
                  type="number"
                />
              </Col>
              <Col md={6}>
                <Label version={1} weight="bold">
                  Ansatte til
                </Label>
                <Input
                  placeholder="Velg"
                  onChange={(e) => selectFilterEmployeesTo(e.target.value)}
                  min={`${minEmployees}`}
                  type="number"
                />
              </Col>
            </Row>
            <Row className="details-row">
              <Col md={6}>
                <Label version={1} weight="bold">
                  Registreringsdato fra
                </Label>
                <Input
                  onChange={(e) =>
                    setFilterRegistrationDateFrom(e.target.value)
                  }
                  type="date"
                />
              </Col>
              <Col md={6}>
                <Label version={1} weight="bold">
                  Registreringsdato til
                </Label>
                <Input
                  onChange={(e) => setFilterRegistrationDateTo(e.target.value)}
                  type="date"
                />
              </Col>
            </Row>
            <Row className="details-row">
              <Col md={6}>
                <Label version={1} weight="bold">
                  Organisasjonsform
                </Label>
                <Select
                  onChange={(e) => selectFilterOrganizationType(e.target.value)}
                  items={organizationTypes}
                />
              </Col>
              <Col md={6}>
                <Label version={1} weight="bold">
                  Registrert i MVA-registeret
                </Label>
                <Select
                  onChange={(e) => selectFilterIsVatRegistered(e.target.value)}
                  items={booleans}
                />
              </Col>
            </Row>
            <Row className="details-row">
              <Col md={6}>
                <Label version={1} weight="bold">
                  Registrert i Foretaksregisteret
                </Label>
                <Select
                  onChange={(e) =>
                    selectFilterInBusinessRegister(e.target.value)
                  }
                  items={booleans}
                />
              </Col>
              <Col md={6}>
                <Label version={1} weight="bold">
                  Registrert i Stiftelsesregisteret
                </Label>
                <Select
                  onChange={(e) =>
                    selectFilterInFoundationRegister(e.target.value)
                  }
                  items={booleans}
                />
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
